const employeeStatusFilters = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};

export default employeeStatusFilters;
